import { render, staticRenderFns } from "./contractList1400.vue?vue&type=template&id=8167cd24"
import script from "./contractList1400.vue?vue&type=script&lang=js"
export * from "./contractList1400.vue?vue&type=script&lang=js"
import style0 from "./contractList1400.vue?vue&type=style&index=0&id=8167cd24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports